import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { useProducts } from '../hooks/useProducts';
import ProductCard from '../components/ProductCard';
import BottomNav from '../components/BottomNav';

const DEMO_ORDERS = [
  { id: 'NBS-R-20251022-441', date: '22 Oct 2025', items: 'Linen co-ord (×4), Necklace (×4), Kurti (×4)', total: 7084, qty: 12, status: 'transit' },
  { id: 'NBS-R-20251008-389', date: '8 Oct 2025', items: 'Cargo trousers (×10), Bangles (×10)', total: 17890, qty: 20, status: 'delivered' },
];

export default function ResellerDashboard() {
  const { user, logout } = useStore();
  const { products, loading } = useProducts();
  const navigate = useNavigate();

  if (!user || user.type !== 'reseller') return (
    <div className="app-shell">
      <div style={{ padding: 40, textAlign: 'center' }}>
        <i className="ti ti-building-store" style={{ fontSize: 48, color: 'var(--muted)', marginBottom: 16 }}></i>
        <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 8 }}>Reseller access required</div>
        <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 24 }}>Please sign in with your reseller account</div>
        <button className="btn-primary" style={{ width: 200 }} onClick={() => navigate('/login?tab=reseller')}>Reseller sign in</button>
      </div>
    </div>
  );

  return (
    <div className="app-shell">
      <nav style={{ background: 'var(--navy)', padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 }}>
        <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--off-white)', letterSpacing: '0.08em' }}>Reseller dashboard</span>
        <div style={{ display: 'flex', gap: 14 }}>
          <i className="ti ti-bell" style={{ fontSize: 20, color: 'var(--off-white)' }}></i>
          <i className="ti ti-settings" style={{ fontSize: 20, color: 'var(--off-white)' }}></i>
        </div>
      </nav>

      <div style={{ background: 'var(--navy)', padding: '0 18px 24px' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'var(--gold)', color: 'var(--navy)', fontSize: 10, padding: '4px 12px', borderRadius: 2, fontWeight: 500, letterSpacing: '0.06em', marginBottom: 10 }}>
          <i className="ti ti-star" style={{ fontSize: 13 }}></i> Verified reseller
        </div>
        <div style={{ fontSize: 18, fontWeight: 500, color: 'var(--off-white)', marginBottom: 2 }}>{user.name}</div>
        <div style={{ fontSize: 12, color: 'var(--muted)' }}>{user.phone} · Member since 2025</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, padding: '16px 18px' }}>
        {[['34', 'Total orders', '+6 this month'], ['₹48k', 'Total spent', '+₹12k this month'], ['32%', 'Avg. savings', 'vs retail price'], ['3', 'Pending', 'In transit']].map(([val, label, sub]) => (
          <div key={label} className="card" style={{ padding: 14, margin: 0 }}>
            <div style={{ fontSize: 10, color: 'var(--muted)', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 6 }}>{label}</div>
            <div style={{ fontSize: 22, fontWeight: 500, color: 'var(--navy)' }}>{val}</div>
            <div style={{ fontSize: 11, color: 'var(--blue)', marginTop: 2 }}>{sub}</div>
          </div>
        ))}
      </div>

      <div className="page-body" style={{ paddingTop: 0 }}>
        <div className="section-header">
          <span className="section-title">Wholesale catalog</span>
          <button className="see-all">View all →</button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 20, color: 'var(--muted)' }}>Loading products…</div>
        ) : (
          <div className="card" style={{ padding: 0, overflow: 'hidden', marginBottom: 16 }}>
            {products.slice(0, 4).map((p, i) => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderBottom: i < 3 ? '0.5px solid var(--card-border)' : 'none' }}>
                <div style={{ width: 48, height: 48, borderRadius: 6, background: p.category === 'Garments' ? '#EEF2F8' : '#F7F0E2', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <i className={`ti ${p.category === 'Garments' ? 'ti-shirt' : 'ti-diamond'}`} style={{ fontSize: 22, opacity: 0.35, color: 'var(--navy)' }}></i>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--navy)', marginBottom: 2 }}>{p.name}</div>
                  <div style={{ fontSize: 10, color: 'var(--muted)', textDecoration: 'line-through' }}>Retail ₹{p.price.toLocaleString()}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
                    <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--green)' }}>₹{p.resellerPrice.toLocaleString()}</span>
                    <span style={{ fontSize: 10, color: 'var(--green)', background: 'var(--green-bg)', padding: '2px 6px', borderRadius: 2 }}>
                      Save {Math.round(((p.price - p.resellerPrice) / p.price) * 100)}%
                    </span>
                  </div>
                </div>
                <button style={{ background: 'var(--navy)', border: 'none', color: 'var(--off-white)', padding: '7px 14px', borderRadius: 4, fontSize: 11, cursor: 'pointer', fontFamily: 'var(--font)', whiteSpace: 'nowrap' }}>
                  Add
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="section-header">
          <span className="section-title">Recent orders</span>
          <button className="see-all">All orders →</button>
        </div>

        {DEMO_ORDERS.map(order => (
          <div key={order.id} className="card" style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <div>
                <div style={{ fontSize: 12, fontWeight: 500 }}>{order.id}</div>
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>{order.date} · {order.qty} items</div>
              </div>
              <span className={`badge ${order.status === 'transit' ? 'badge-blue' : 'badge-green'}`}>
                {order.status === 'transit' ? 'In transit' : 'Delivered'}
              </span>
            </div>
            <div style={{ fontSize: 12, color: '#555', marginBottom: 8 }}>{order.items}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 14, fontWeight: 500 }}>₹{order.total.toLocaleString()}</span>
              <div style={{ display: 'flex', gap: 12 }}>
                <button style={{ fontSize: 12, color: 'var(--blue)', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--font)' }}>Invoice</button>
                <button style={{ fontSize: 12, color: 'var(--blue)', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--font)' }}>
                  {order.status === 'transit' ? 'Track →' : 'Reorder →'}
                </button>
              </div>
            </div>
          </div>
        ))}

        <div className="section-title" style={{ marginBottom: 10, marginTop: 8 }}>Quick actions</div>
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {[
            ['ti-file-invoice', 'Download invoices', '#E1F5EE', 'var(--green)'],
            ['ti-layout-grid', 'Full wholesale catalog', '#EEF4FF', 'var(--blue)'],
            ['ti-headset', 'Talk to support', '#FEF8E8', 'var(--gold)'],
          ].map(([icon, label, bg, color], i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', borderBottom: i < 2 ? '0.5px solid var(--card-border)' : 'none', cursor: 'pointer' }}>
              <div style={{ width: 34, height: 34, borderRadius: 8, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className={`ti ${icon}`} style={{ fontSize: 18, color }}></i>
              </div>
              <span style={{ flex: 1, fontSize: 13 }}>{label}</span>
              <i className="ti ti-chevron-right" style={{ fontSize: 16, color: 'var(--muted)' }}></i>
            </div>
          ))}
        </div>

        <button onClick={() => { logout(); navigate('/'); }} style={{ width: '100%', padding: 13, marginTop: 16, background: 'transparent', border: '0.5px solid rgba(226,75,74,0.3)', color: 'var(--red)', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontFamily: 'var(--font)' }}>
          Sign out
        </button>
      </div>

      <BottomNav />
    </div>
  );
}
